module.exports = __webpack_public_path__ + "img/salary.5b93a870.svg";